/**
 * Handles OAuth callback: exchanges session_id (in URL fragment) for a session cookie.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      let dest = "/";
      try {
        const saved = sessionStorage.getItem("post_login_return_to");
        if (saved) {
          dest = saved;
          sessionStorage.removeItem("post_login_return_to");
        }
      } catch (_) {}
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/");
        // Full reload so AuthProvider re-fetches /auth/me (populates role for gated routes like /admin).
        window.location.replace(dest);
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex items-center gap-3 text-black/70">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Signing you in…</span>
      </div>
    </div>
  );
}
